export const AW_NEWS_API_URL = process.env?.AWAPI_NEWS_URL || '/api/wealth/analytics/news';
